import {observer, React} from '@api'
import {useWhiteboardStore} from '@modules/whiteboard'
import { RowButton } from '~components/RowButton'
import { MenuContent } from '~components/MenuContent'
import * as css from './BackToContent.css'

export const BackToContent = observer(function BackToContent() {
    const {isEmptyCanvas, shapes, isInSession,camera: {zoomToContent}} = useWhiteboardStore()

  if (!isEmptyCanvas || shapes.length === 0 || isInSession) return null

  return (
    <MenuContent className={css.root}>
      <RowButton onClick={zoomToContent}>Back to content</RowButton>
    </MenuContent>
  )
})



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/ToolsPanel/BackToContent.tsx